import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function reportReducer(state = initialState.reported, action) {
  switch (action.type) {
    case types.ADD_REPORT_SUCCESS:
      return true;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./library/app/reducers/reportReducer.js